package com.nonopn.skywatcher.design.utils

import androidx.compose.runtime.Composable
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.getString
import org.jetbrains.compose.resources.stringResource

@Composable
fun StringResource.localized() = stringResource(this)

suspend fun StringResource.get() = getString(this)

